import script from "./InvoiceAttachmentsDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./InvoiceAttachmentsDialog.vue?vue&type=script&lang=ts&setup=true"

import "./InvoiceAttachmentsDialog.vue?vue&type=style&index=0&id=08c0a6c5&lang=sass&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\agrii-carrier-prod\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08c0a6c5"]])

export default __exports__